
























import Vue from "vue";
import { mapState, mapActions } from "vuex";
export default Vue.extend({
  computed: {
    ...mapState("uiModule", {
      alerts: "alerts",
    }),
    alert(): any {
      return (this as any).alerts;
    },
  },
  inject: ["actionHandler"],
  methods: {
    consumeAlert(type: string) {
      if (type) {
        (this as any).actionHandler("meetWithClient", (this as any).alert[0]);
      }
      (this as any).$store.commit("uiModule/consumeAlert", { type: type });
    },
  },
});
